define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GenerateAndRespondTermConsentCommand = (function () {
        function GenerateAndRespondTermConsentCommand(routeId, protocol, cpf, birthDate, email, accepted, geoLocation, termActivityAnswers, termVersionId) {
            this.Protocol = '';
            this.Accepted = false;
            this.RouteId = 0;
            this.CPF = '';
            this.Email = '';
            this.BirthDate = new Date();
            this.GeoLocation = null;
            this.TermActivityAnswers = null;
            this.Protocol = protocol;
            this.Accepted = accepted;
            this.RouteId = routeId;
            this.CPF = cpf;
            this.Email = email;
            this.BirthDate = birthDate;
            this.GeoLocation = geoLocation;
            this.TermActivityAnswers = termActivityAnswers;
            this.TermVersionId = termVersionId;
        }
        return GenerateAndRespondTermConsentCommand;
    }());
    exports.default = GenerateAndRespondTermConsentCommand;
});
